import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import history from 'utils/history';

import Form from '../components/Form';
import { useTagStore } from '../store';

const TagForm = () => {
  const { content_type, id } = useParams()
  const { collection: { item, useLoad, useSubmit, deleteEntry, reset }, collections: { list: refresh } } = useTagStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)

  const handleSubmit = useSubmit()

  const handleClose = useCallback(() => {
    reset()
    history.push(`./`);
  }, [reset])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit({ ...payload, content_type })
      await refresh()
      const message = payload.id ? 'edited' : 'created';
      handleSuccess('Success', `Category ${message}.`)
      handleClose()
    } catch {
      handleError('Error', `Category was not saved.`)
    }
  }, [content_type, handleSubmit, refresh, handleClose, handleSuccess, handleError])

  const handleDelete = useCallback(async category => {
    try {
      await deleteEntry(category)
      await refresh()
      handleSuccess('Success', `Category deleted.`);
    } catch {
      handleError('Error', `Category was not deleted.`);
    } finally {
      reset()
      history.push(`./`);
    }
  }, [deleteEntry, refresh, reset, handleSuccess, handleError])

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
      title={id ? `Edit ${item?.name}` : 'Add Category'}
    >
      <Form data={item}
        onSubmit={handleSubmitAndClose}
        onDelete={handleDelete}
        contentType={content_type}
      />
    </DefaultSheet>
  </>
}

export default function TagFormLayout() {
  return <TagForm />
}

